if (!customElements.get('reverse-counter')) {
    class ReverseCounter extends HTMLElement {
        constructor() {
            super();
            this.eventDate = null;
            this.timerInterval = null;
            this.isAlternativeStyle = false;
            this.isEveryWeekMode = false;
            this.showAlternativeDays = false;
        }

        connectedCallback() {
            if (this.children.length === 0) {
                requestAnimationFrame(() => this.init());
            } else {
                this.init();
            }
        }

        disconnectedCallback() {
            this.clearTimer();
        }

        init() {
            this.isAlternativeStyle = this.dataset.styleType === 'alternative';
            this.isEveryWeekMode = this.dataset.countdownMode === 'every_week';
            this.showAlternativeDays = this.dataset.showAlternativeDays === 'true';

            this.parseEventDate();
            if (!this.eventDate) return;

            this.cacheElements();
            if (!this.elementsReady()) return;
            this.applyStyleType();

            this.update();
            this.startTimer();

            this.classList.add("bf-back__counter--initialized");
        }

        parseEventDate() {
            const timestamp = this.isEveryWeekMode
                ? this.getNextWeeklyTimestamp()
                : new Date(this.dataset.eventDate).getTime();

            if (isNaN(timestamp)) {
                console.error('Invalid event date:', this.dataset.eventDate);
                return;
            }

            this.eventDate = timestamp;
        }

        getNextWeeklyTimestamp() {
            const dateString = this.dataset.eventDate;
            const timestamp = new Date(dateString).getTime();

            if (isNaN(timestamp)) return NaN;

            const weekInMs = 7 * 24 * 60 * 60 * 1000;
            let nextTimestamp = timestamp;

            while (nextTimestamp <= Date.now()) {
                nextTimestamp += weekInMs;
            }

            return nextTimestamp;
        }

        cacheElements() {
            const get = (type, elementClass) =>
                this.querySelector(`[data-time-type="${type}"] .${elementClass}`);

            this.elements = {
                days: get('D', 'time-block__value'),
                daysUnit: get('D', 'time-block__unit'),
                daysWrapper: this.querySelector(`[data-time-type="D"]`),

                hours: get('H', 'time-block__value'),
                hoursUnit: get('H', 'time-block__unit'),
                minutes: get('M', 'time-block__value'),
                minutesUnit: get('M', 'time-block__unit'),
                seconds: get('S', 'time-block__value'),
                secondsUnit: get('S', 'time-block__unit'),
            };
        }

        elementsReady() {
            const { days, hours, minutes, seconds } = this.elements;
            if ((!this.isAlternativeStyle && !days) || !hours || !minutes || !seconds) {
                console.warn('Missing required DOM elements');
                return false;
            }
            return true;
        }

        applyStyleType() {
            if (!this.isAlternativeStyle) return;

            if (this.elements.daysWrapper && !this.showAlternativeDays) {
                this.elements.daysWrapper.style.display = 'none';
            }

            if (this.elements.daysUnit && this.showAlternativeDays) {
                this.elements.daysUnit.textContent = 'd';
            }
            if (this.elements.hoursUnit) {
                this.elements.hoursUnit.textContent = 'h';
            }
            if (this.elements.minutesUnit) {
                this.elements.minutesUnit.textContent = 'm';
            }
            if (this.elements.secondsUnit) {
                this.elements.secondsUnit.textContent = 's';
            }
        }

        startTimer() {
            this.timerInterval = setInterval(() => this.update(), 1000);
        }

        clearTimer() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timerInterval = null;
            }
        }

        update() {
            const now = Date.now();
            let difference = this.eventDate - now;

            if (difference <= 0 && this.isEveryWeekMode) {
                this.parseEventDate();
                difference = this.eventDate - now;
            }

            if (difference <= 0) {
                this.render(0);
                this.clearTimer();
                return;
            }

            this.render(difference);
        }

        render(difference) {
            const pad = (n) => String(n).padStart(2, '0');

            const totalSeconds = Math.floor(difference / 1000);
            const days = Math.floor(totalSeconds / 86400);
            const hours = this.isAlternativeStyle && !this.showAlternativeDays
                ? Math.floor(totalSeconds / 3600)
                : Math.floor((totalSeconds % 86400) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            if (this.isAlternativeStyle && !this.showAlternativeDays) {
                if (this.elements.daysWrapper) {
                    this.elements.daysWrapper.style.display = 'none';
                }
            } else if (days > 0) {
                this.elements.days.textContent = days;
                if (this.elements.daysUnit) {
                    this.elements.daysUnit.textContent = this.isAlternativeStyle ? 'd' : days > 1 ? 'DAYS' : 'DAY';
                }
                if (this.elements.daysWrapper) {
                    this.elements.daysWrapper.style.display = '';
                }
            } else if (this.elements.daysWrapper) {
                this.elements.daysWrapper.style.display = 'none';
            }

            this.elements.hours.textContent = pad(hours);
            this.elements.minutes.textContent = pad(minutes);
            this.elements.seconds.textContent = pad(seconds);

            if (difference == 0) {
                this.style.opacity = '0';
                this.style.visibility = 'hidden'
                this.classList.add('counter--expired')
            }
        }
    }

    customElements.define('reverse-counter', ReverseCounter);
}
